


































































































































import { Vue, Component, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import { InputFactory, ICampoTemplate } from '@/components/inputs'
import SolicitacaoStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoStore'
import SolicitacaoCirurgiaStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoCirurgiaStore'

const CONSULTA_AUTORIZACAO_STORAGE_KEY = 'consulta-autorizacao-context'

type ConsultaAutorizacaoContexto = {
  hospitalId?: string,
  convenioId?: string,
  medicoId?: string,
  templateOperadora?: any,
  historicoImportacoes?: any[],
}

@Component({
  name: 'ConsultaAutorizacao',
})
export default class ConsultaAutorizacao extends Vue {
  loadingEnviarAutorizacao: boolean = false
  loadingHistorico: boolean = false
  loadingClosePage: boolean = false
  camposLocais: ICampoTemplate[] = []
  historicoImportacoes: any[] = []
  proximoClique: number = 0
  intervaloAtualizacao: any = null
  tempoMinimoBotao: number = 30 // segundos
  hospitalIdAtual: string = ''
  convenioIdAtual: string = ''
  medicoIdAtual: string = ''
  templateOperadoraAtual: any = {}
  private carregandoHistorico = false

  headersTabela = [
    { text: 'Médico', value: 'nomeMedico', sortable: false },
    { text: 'Convênio', value: 'nomeConvenio', sortable: false },
    { text: 'Detalhes', value: 'detalhesImportacao', sortable: false },
    { text: 'Data Importação', value: 'dataImportacao', sortable: false },
    { text: 'Data Atualização', value: 'dataAtualizacao', sortable: false },
    { text: 'Status', value: 'status', sortable: false },
    { text: 'Mensagem Erro', value: 'mensagemErro', sortable: false },
  ]

  private get contextoPersistido(): ConsultaAutorizacaoContexto {
    try {
      const contexto = sessionStorage.getItem(CONSULTA_AUTORIZACAO_STORAGE_KEY)
      return contexto ? JSON.parse(contexto) : {}
    } catch (error) {
      console.error('Erro ao recuperar contexto da consulta de autorização:', error)
      return {}
    }
  }

  private getValorDaRota(valor: any): string {
    if (Array.isArray(valor)) {
      return valor[0] || ''
    }

    return typeof valor === 'string' ? valor : ''
  }

  get templateOperadora() {
    return this.templateOperadoraAtual && typeof this.templateOperadoraAtual === 'object' ? this.templateOperadoraAtual : {}
  }

  get campos(): ICampoTemplate[] {
    return this.camposLocais.length > 0 ? this.camposLocais : (this.templateOperadora.campos || [])
  }

  get podeAtualizarTabela(): boolean {
    return this.proximoClique === 0
  }

  get contextoRequisicao() {
    return {
      hospitalId: this.hospitalIdAtual,
      convenioId: this.convenioIdAtual,
      medicoId: this.medicoIdAtual,
    }
  }

  get hospitalId() {
    return this.hospitalIdAtual
  }

  get convenioId() {
    return this.convenioIdAtual
  }

  get medicoId() {
    return this.medicoIdAtual
  }

  get getSolicitacaoStore() {
    return getModule(SolicitacaoStore, this.$store)
  }

  get solicitacaoCirurgiaStore() {
    return getModule(SolicitacaoCirurgiaStore, this.$store)
  }

  /**
   * Factory pattern - Retorna o componente correto baseado no tipo de campo
   */
  getComponentForField(campo: ICampoTemplate): any {
    return InputFactory.createInput(campo)
  }

  /**
   * Atualiza o valor de um campo específico
   */
  atualizarCampo(idx: number, novoValor: any) {
    if (this.camposLocais.length === 0) {
      // Primeira vez que atualiza, copiar campos do template
      this.camposLocais = JSON.parse(JSON.stringify(this.campos))
    }
    this.camposLocais[idx].valor = novoValor
  }

  /**
   * Envia os dados dos campos preenchidos para a API
   */
  async enviarAutorizacao() {
    const formulario: any = this.$refs.formularioAutorizacao
    if (!formulario || !formulario.validate()) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Por favor, corrija os erros no formulário',
        icon: 'warning',
        color: '#C62828',
      })
      return
    }

    const { hospitalId, convenioId, medicoId } = this.contextoRequisicao
    if (!hospitalId || !convenioId || !medicoId) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Não foi possível identificar hospital, convênio ou médico para enviar a autorização',
        icon: 'warning',
        color: '#C62828',
      })
      return
    }

    this.loadingEnviarAutorizacao = true

    try {
      const camposParaEnviar = (this.camposLocais.length > 0 ? this.camposLocais : this.campos)
        .map((campo: ICampoTemplate) => this.normalizarCampoParaEnvio(campo))

      await this.solicitacaoCirurgiaStore.enviarAutorizacaoOperadora({
        hospitalId,
        convenioId,
        medicoId,
        campos: camposParaEnviar,
      })

      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Importação iniciada. Avisaremos por e-mail quando for concluída.',
        icon: 'check_circle',
        color: '#4CAF50',
        timeout: 10000,
      })

      this.limparCampos()

      setTimeout(() => {
        this.carregarHistoricoComRetry(2, true)
      }, 1000)
    } catch (e) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Erro ao enviar autorização',
        icon: 'warning',
        color: '#C62828',
      })
      console.error('Erro ao enviar autorização', e)
    } finally {
      this.loadingEnviarAutorizacao = false
    }
  }

  showModalSair() {
    sessionStorage.removeItem(CONSULTA_AUTORIZACAO_STORAGE_KEY)
    this.solicitacaoCirurgiaStore.clearSolicitacaoCirurgia()
    this.getSolicitacaoStore.clearSolicitacao()
    this.$router.push('/agendamento-medico')
  }

  /**
   * Inicializa componente com cópia dos campos e carrega histórico
   */
  mounted() {
    this.resolverContextoInicial()
    this.persistirContexto()
    this.restaurarHistoricoPersistido()
    this.$nextTick(() => {
      this.carregarTemplate()
      this.carregarHistoricoComRetry()
    })
  }

  @Watch('$route', { deep: true })
  onRouteAlterada() {
    this.resolverContextoInicial()
    this.persistirContexto()
    this.carregarHistoricoComRetry()
  }

  private normalizarTemplate(template: any) {
    if (typeof template === 'string') {
      try {
        return JSON.parse(template)
      } catch {
        return {}
      }
    }

    return template && typeof template === 'object' ? template : {}
  }

  private resolverContextoInicial() {
    const { contextoPersistido } = this
    const templateDaRota = this.$route.params.templateOperadora || this.getValorDaRota(this.$route.query.templateOperadora)
    const templateNormalizado = this.normalizarTemplate(templateDaRota || contextoPersistido.templateOperadora)

    this.templateOperadoraAtual = templateNormalizado
    this.hospitalIdAtual = this.getValorDaRota(this.$route.params.hospitalId) || this.getValorDaRota(this.$route.query.hospitalId) || templateNormalizado.hospitalId || contextoPersistido.hospitalId || ''
    this.convenioIdAtual = this.getValorDaRota(this.$route.params.convenioId) || this.getValorDaRota(this.$route.query.convenioId) || templateNormalizado.convenioId || contextoPersistido.convenioId || ''
    this.medicoIdAtual = this.getValorDaRota(this.$route.params.medicoId) || this.getValorDaRota(this.$route.query.medicoId) || contextoPersistido.medicoId || (this.$user && this.$user.profile && this.$user.profile.sub) || ''
  }

  private persistirContexto(templateOperadora?: any) {
    const { hospitalId } = this
    const { convenioId } = this
    const { medicoId } = this

    if (!hospitalId && !convenioId && !medicoId && !templateOperadora && !this.templateOperadora.campos) {
      return
    }

    const contextoAtual = this.contextoPersistido
    const proximoContexto: ConsultaAutorizacaoContexto = {
      ...contextoAtual,
      hospitalId: hospitalId || contextoAtual.hospitalId,
      convenioId: convenioId || contextoAtual.convenioId,
      medicoId: medicoId || contextoAtual.medicoId,
      templateOperadora: templateOperadora || this.templateOperadora || contextoAtual.templateOperadora,
      historicoImportacoes: this.historicoImportacoes.length > 0 ? this.historicoImportacoes : contextoAtual.historicoImportacoes,
    }

    sessionStorage.setItem(CONSULTA_AUTORIZACAO_STORAGE_KEY, JSON.stringify(proximoContexto))
  }

  private restaurarHistoricoPersistido() {
    const historicoPersistido = this.contextoPersistido.historicoImportacoes

    if (Array.isArray(historicoPersistido) && historicoPersistido.length > 0) {
      this.historicoImportacoes.splice(0)
      this.historicoImportacoes.push(...historicoPersistido)
    }
  }

  private normalizarCampoParaEnvio(campo: ICampoTemplate) {
    return JSON.parse(JSON.stringify({
      nome: campo.nome,
      label: campo.label,
      tipoDoCampo: campo.tipoDoCampo,
      valor: campo.valor,
      obrigatorio: campo.obrigatorio,
      desabilitado: campo.desabilitado,
      hint: campo.hint,
      maxLength: campo.maxLength,
      minLength: campo.minLength,
      min: campo.min,
      max: campo.max,
      mascara: campo.mascara,
      opcoes: campo.opcoes,
      cols: campo.cols,
      colsMd: campo.colsMd,
      colsSm: campo.colsSm,
      propriedadesAdicionais: campo.propriedadesAdicionais,
    }))
  }

  private async carregarHistoricoComRetry(tentativasRestantes: number = 3, forcar: boolean = false): Promise<boolean> {
    if (this.carregandoHistorico && !this.loadingHistorico) {
      this.carregandoHistorico = false
    }

    if (this.carregandoHistorico && !forcar) {
      return false
    }

    if (this.loadingHistorico && forcar) {
      return false
    }

    const { hospitalId, medicoId, convenioId } = this.contextoRequisicao

    if (!hospitalId || !medicoId || !convenioId) {
      if (tentativasRestantes > 1) {
        setTimeout(() => {
          this.carregarHistoricoComRetry(tentativasRestantes - 1, forcar)
        }, 600)
      }
      return false
    }

    this.carregandoHistorico = true

    try {
      await this.carregarHistorico()
      return true
    } catch (erro) {
      if (tentativasRestantes > 1) {
        setTimeout(() => {
          this.carregandoHistorico = false
          this.carregarHistoricoComRetry(tentativasRestantes - 1, forcar)
        }, 800)
        return false
      }

      if (this.historicoImportacoes.length === 0) {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: 'Erro ao carregar histórico de importações',
          icon: 'warning',
          color: '#C62828',
        })
      }
      return false
    } finally {
      this.carregandoHistorico = false
    }
  }

  /**
   * Carrega o histórico de importações
   */
  async carregarHistorico() {
    const { hospitalId, medicoId, convenioId } = this.contextoRequisicao

    if (!hospitalId || !medicoId || !convenioId) {
      return
    }

    this.loadingHistorico = true
    try {
      const resultado = await this.solicitacaoCirurgiaStore.getHistoricoImportacoes({
        hospitalId,
        medicoId,
        convenioId,
      })

      if (!Array.isArray(resultado)) {
        throw new Error('Resposta inválida ao carregar histórico de importações')
      }

      // Mapear dados da API para a estrutura esperada pela tabela
      const mapeados = resultado.map((item: any, idx: number) => ({
        id: `historico-${idx}-${Date.now()}`,
        nomeMedico: item.nomeMedico || '-',
        nomeConvenio: item.nomeConvenio || '-',
        detalhesImportacao: item.detalhesImportacao || '-',
        dataImportacao: item.dataImportacao,
        dataAtualizacao: item.dataAtualizacao,
        status: item.status || '-',
        mensagemErro: item.mensagemErro || null,
      }))

      // Ordenar por data de importação (mais recente primeiro)
      mapeados.sort((a: any, b: any) => {
        const dataA = new Date(a.dataImportacao).getTime()
        const dataB = new Date(b.dataImportacao).getTime()
        return dataB - dataA // Descendente
      })

      // Limpar array e adicionar novos itens (Vue detecta mudanças com splice + push)
      this.historicoImportacoes.splice(0)
      this.historicoImportacoes.push(...mapeados)
      this.persistirContexto()
    } catch (erro) {
      this.restaurarHistoricoPersistido()
      console.error('Erro ao carregar histórico:', erro)
      throw erro
    } finally {
      this.loadingHistorico = false
    }
  }

  /**
   * Limpa todos os campos do formulário
   */
  private limparCampos() {
    if (this.camposLocais.length > 0) {
      this.camposLocais.forEach((campo: any) => {
        // Reset baseado no tipo de campo
        if (campo.tipo === 'text' || campo.tipo === 'textarea' || campo.tipo === 'select') {
          campo.valor = ''
        } else if (campo.tipo === 'toggle' || campo.tipo === 'checkbox') {
          campo.valor = false
        } else if (campo.tipo === 'radio') {
          campo.valor = null
        } else if (Array.isArray(campo.valor)) {
          campo.valor = []
        } else {
          campo.valor = ''
        }
      })
    }

    // Resetar validação do formulário
    const formulario: any = this.$refs.formularioAutorizacao
    if (formulario) {
      formulario.resetValidation()
    }
  }

  /**
   * Carrega o template da operadora
   */
  async carregarTemplate() {
    // Se o template foi passado como parâmetro de rota, usar diretamente sem fazer requisição
    if (this.templateOperadora.campos) {
      this.camposLocais = JSON.parse(JSON.stringify(this.templateOperadora.campos))
      this.persistirContexto(this.templateOperadora)
      return
    }

    const { hospitalId } = this
    const { convenioId } = this

    if (!hospitalId || !convenioId) {
      this.camposLocais = []
      return
    }

    try {
      const resultado = await this.solicitacaoCirurgiaStore.getTemplateOperadora({
        hospitalId,
        convenioId,
      })
      if (resultado && resultado.campos) {
        this.camposLocais = JSON.parse(JSON.stringify(resultado.campos))
        this.persistirContexto(resultado)
      }
    } catch (erro) {
      console.error('Erro ao carregar template:', erro)
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Erro ao carregar template da operadora',
        icon: 'warning',
        color: '#C62828',
      })
    }
  }

  /**
   * Atualiza o histórico com proteção contra múltiplos cliques
   */
  async atualizarHistorico() {
    // Impedir clique se já está em cooldown
    if (!this.podeAtualizarTabela) {
      return
    }

    // Carregar histórico
    const atualizouHistorico = await this.carregarHistoricoComRetry(1, true)

    // Iniciar timer de proteção
    if (atualizouHistorico) {
      this.iniciarCooldown()
    }
  }

  /**
   * Inicia o cooldown para o botão de atualizar
   */
  private iniciarCooldown() {
    this.proximoClique = this.tempoMinimoBotao

    // Limpar intervalo anterior se existir
    if (this.intervaloAtualizacao) {
      clearInterval(this.intervaloAtualizacao)
    }

    // Iniciar novo intervalo
    this.intervaloAtualizacao = setInterval(() => {
      this.proximoClique -= 1
      if (this.proximoClique <= 0) {
        clearInterval(this.intervaloAtualizacao)
        this.proximoClique = 0
      }
    }, 1000)
  }

  /**
   * Formata uma data ISO para formato legível
   */
  formatarData(dataISO: string): string {
    if (!dataISO) return '-'
    const data = new Date(dataISO)
    return data.toLocaleDateString('pt-BR', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    })
  }

  /**
   * Retorna a cor do chip baseado no status
   */
  getStatusColor(status: string): string {
    const cores: { [key: string]: string } = {
      Cancelado: '#F44336',
      Sucesso: '#4CAF50',
      Pendente: '#FF9800',
      Erro: '#F44336',
    }
    return cores[status] || '#9E9E9E'
  }

  /**
   * Limpeza ao destruir o componente
   */
  beforeDestroy() {
    if (this.intervaloAtualizacao) {
      clearInterval(this.intervaloAtualizacao)
    }
  }
}
